import Swiper from 'swiper';
import { FreeMode, Mousewheel, Navigation, Scrollbar } from 'swiper/modules';

/**
 * Init Carousel.
 * @param {HTMLElement} rootElement - The root element.
 * @return {void}
 */
function initCarousel( rootElement ) {
	// Pass elements, not selector strings so we can target each carousel when
	// there are multiple ones on a page. Fix RTES 513.
	const prevEl = rootElement.querySelector( '.swiper-button-prev' );
	const nextEl = rootElement.querySelector( '.swiper-button-next' );
	const hasNavigation = Boolean( prevEl || nextEl );

	const swiper = new Swiper( rootElement, {
		enabled: false,
		createElements: true,
		modules: [ FreeMode, Mousewheel, Navigation, Scrollbar ],
		mousewheel: { releaseOnEdges: true, forceToAxis: true, enabled: true },
		slidesPerView: 'auto',
		slideClass: 'rte-carousel--slide',
		spaceBetween: 16,
		wrapperClass: 'rte-carousel--wrapper',
		slidesOffsetAfter: 4,
		navigation: {
			enabled: hasNavigation,
			prevEl,
			nextEl,
		},
		breakpoints: {
			1024: {
				scrollbar: {
					hide: false,
					draggable: true,
					enabled: true,
					el: '.swiper-scrollbar',
				},
				navigation: { enabled: hasNavigation },
				freeMode: { enabled: true },
				slidesPerView: 3,
				spaceBetween: 24,
				slidesOffsetAfter: 0,
				touchRatio: 1, // 1 is default
				longSwipesRatio: 0.5, // 0.5 is default
			},
			1280: {
				scrollbar: {
					hide: false,
					draggable: true,
					enabled: true,
					el: '.swiper-scrollbar',
				},
				navigation: { enabled: hasNavigation },
				freeMode: { enabled: true },
				slidesPerView: 4,
				spaceBetween: 24,
				slidesOffsetAfter: 0,
				touchRatio: 1, // 1 is default
				longSwipesRatio: 0.5, // 0.5 is default
			},
			1536: {
				scrollbar: {
					hide: false,
					draggable: true,
					enabled: true,
					el: '.swiper-scrollbar',
				},
				navigation: { enabled: hasNavigation },
				freeMode: { enabled: true },
				spaceBetween: 24,
				slidesPerView: 5,
				slidesOffsetAfter: 0,
				touchRatio: 1, // 1 is default
				longSwipesRatio: 0.5, // 0.5 is default
			},
		},
		scrollbar: {
			hide: false,
			draggable: true,
			enabled: true,
			el: '.swiper-scrollbar',
		},
		// freeMode: { enabled: true, momentumBounce: true },
		touchRatio: 2,
		longSwipes: true,
		longSwipesRatio: 0.1,
	} );

	// For single group carousel, enable it.
	if ( rootElement.classList.contains( 'rte-carousel-single' ) ) {
		swiper.enable();
		swiper.scrollbar.updateSize();
	}
}

export default initCarousel;
